/**
 * Lightweight logger for DEV mode only
 * Disabled in production
 */

const isDev = import.meta.env.DEV;

interface LogContext {
  action?: string;
  component?: string;
  userId?: string;
  workspaceId?: string;
  [key: string]: any;
}

class Logger {
  private shouldLog(): boolean {
    return isDev;
  }

  action(action: string, context?: LogContext) {
    if (!this.shouldLog()) return;
    console.log(`[ACTION] ${action}`, context || '');
  }

  click(component: string, action: string, context?: LogContext) {
    if (!this.shouldLog()) return;
    console.log(`[CLICK] ${component}.${action}`, context || '');
  }

  query(queryName: string, context?: LogContext) {
    if (!this.shouldLog()) return;
    console.log(`[QUERY] ${queryName}`, context || '');
  }

  mutation(mutationName: string, context?: LogContext) {
    if (!this.shouldLog()) return;
    console.log(`[MUTATION] ${mutationName}`, context || '');
  }

  info(message: string, context?: LogContext) {
    if (!this.shouldLog()) return;
    console.log(`[INFO] ${message}`, context || '');
  }

  warn(message: string, context?: LogContext) {
    // Always log warnings, even in production (but only to console)
    console.warn(`[WARN] ${message}`, context || '');
  }

  error(message: string, error: Error | unknown, context?: LogContext) {
    // Always log errors, even in production (but only to console)
    console.error(`[ERROR] ${message}`, {
      error,
      ...context,
    });
  }

  supabase(operation: string, table: string, context?: LogContext) {
    if (!this.shouldLog()) return;
    console.log(`[SUPABASE] ${operation} ${table}`, context || '');
  }
}

export const logger = new Logger();

